/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Address } from '../models/Address';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AddressService {
    /**
     * Get all user addresses
     * @returns Address A list of user addresses
     * @throws ApiError
     */
    public static getAddress(): CancelablePromise<Array<Address>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/address',
        });
    }
    /**
     * Create a new user address
     * @param requestBody
     * @returns any Address created
     * @throws ApiError
     */
    public static postAddress(
        requestBody: {
            user_id?: string;
            address?: string;
            city?: string;
            state?: string;
            zip?: string;
            country?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/address',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get address by ID
     * @param id
     * @returns Address Address details
     * @throws ApiError
     */
    public static getAddress1(
        id: string,
    ): CancelablePromise<Address> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/address/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Address not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update an existing address
     * @param id
     * @param requestBody
     * @returns any Address updated
     * @throws ApiError
     */
    public static putAddress(
        id: string,
        requestBody: {
            address?: string;
            city?: string;
            state?: string;
            zip?: string;
            country?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/address/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete an address
     * @param id
     * @returns any Address deleted
     * @throws ApiError
     */
    public static deleteAddress(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/address/{id}',
            path: {
                'id': id,
            },
        });
    }
}
